module.exports = __webpack_public_path__ + "DINNextLTPro-BlackCondensed.woff?03a9d5c87499cce6f20aa6409011786c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackCondensed.woff
// module id = 1374
// module chunks = 0